import styled from "styled-components";
import Link from "next/link";
import DropdownIcon from '/public/images/arrow_down_white.svg';
import Image from "next/image";
import {getColor} from "@/styles/ThemeConfig";
import {useEffect, useRef, useState} from "react";
import SliderArrowWhiteIcon from '/public/images/slider_arrow_right_white.svg';
import ForceSSRLink from "@/components/other/ForceSSRLink";


const FixedDropdownWrapper = styled.div`
    background-color: rgba(0,0,0,0.6);
    position:${({isVisible}) => isVisible ? 'absolute' : 'fixed'};
    width:100%;
    top:0;
    left:0;
    
    
    display: flex;
    justify-content: center;
    
    z-index:999;
    
    ${({ isScrollingUp, isVisible }) => !isVisible && isScrollingUp && `
        top: ${isScrollingUp ? '87.83px' : '0'};
        transition: 0.5s ease-in-out;
        transform: ${isScrollingUp ? 'translateY(0)' : 'translateY(100%)'};
    `}
`;

const Wrapper = styled.div`
    position: relative;
    width: 100%;
    gap:30px;
    display: flex;
    justify-content: center;
    align-items: center;
`
const BackButton = styled(ForceSSRLink)`
    padding: 0 20px;
    height: 60px;
    font-size: 16px;
    line-height: 16px;
    color: white;
    text-transform: uppercase;
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
    gap:5px;
    :hover{
        color:${getColor('gold')};
    }
`

const LinkItem = styled(ForceSSRLink)`
    height: 60px;
    color: white;
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
    :hover{
        color:${getColor('gold')};
    }

`
const BookingButton = styled(ForceSSRLink)`
    margin-left: 50px;
    height: 60px;
    
    background-color: ${getColor('red')};
    color: white;
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 240px;
    align-self: flex-end;
    
`
const RedButton = styled(ForceSSRLink)`
    height: 60px;
    background-color: ${getColor('red')};
    color: white;
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    
`
const Dropdown = styled.div`
    position: relative;
    height: 60px;
    
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    cursor: pointer;
    overflow: visible;
    :hover{
        color:${getColor('gold')};
    }

    .dropdown_items{
        display: none;
    }

    :hover{
        .dropdown_items{
            display: flex;
        }
    }
`


const DropdownOptionsWrapper = styled.div`
    z-index: 999;
    
    min-width: 300px;
    
    position: absolute;
    top:60px;
    right:0;
    
    background-color: ${getColor('gold')};
    display: flex;
    flex-direction: column;
    padding: 10px;
    
    
    a{
        padding: 7.5px;
        color: white;
        text-decoration: none;
    }
    
    a:hover{
        background-color: white;
        color:${getColor('gold')};
    }
`
export default function CustomDropdown({items,backButtonLink,backButtonText})
{
    const backButtonRef = useRef();

    const [isScrollingUp, setIsScrollingUp] = useState(true);

    // Detect scroll direction
    useEffect(() => {
        if (typeof window === 'undefined') return;

        let lastScrollTop = 0;

        const handleScroll = () => {
            const currentScrollTop = window.pageYOffset;
            if (currentScrollTop > lastScrollTop) {
                setIsScrollingUp(false); // Scrolling down
            } else {
                setIsScrollingUp(true);  // Scrolling up
            }
            lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);



    function renderItem(item, index){
        switch (item?.item_type) {
            case 'link':
                return <LinkItem key={index} href={item?.item_link ?? '#'}>{item?.item_title}</LinkItem>;
            case 'red_button':
                return <RedButton
                        key={index}
                        href={item?.item_link ?? '#'}
                        dangerouslySetInnerHTML={{__html: item?.item_title?.replace(/ /g, '<br />')}}
                    />;
            case 'booking_button':
                return <BookingButton key={index} href={item?.item_link ?? '#'}>{item?.item_title}</BookingButton>;
            case 'dropdown':
                return <Dropdown key={index}>
                    {item?.item_title}
                    <Image src={DropdownIcon} alt={'v'} />
                    <DropdownOptionsWrapper className={'dropdown_items'}>
                        {
                            item?.dropdown_items?.map( (dropdownItem,index) => {
                                if(!dropdownItem?.tour){
                                    return <ForceSSRLink key={index} href={dropdownItem?.item_link ?? '#'}>{dropdownItem?.item_title}</ForceSSRLink>
                                }else{
                                    return <ForceSSRLink key={index} href={dropdownItem?.tour?.split('|')?.[1] ? '/'+dropdownItem?.tour?.split('|')?.[1] : '#'}>
                                        {decodeURIComponent(dropdownItem?.tour?.split('|')?.[0].replace(/\+/g, ' '))}
                                    </ForceSSRLink>
                                }
                            })
                        }
                    </DropdownOptionsWrapper>
                </Dropdown>;
        }
    }

    const dropdownRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const currentRef = dropdownRef.current; // Store the current value of the ref

        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible(entry.isIntersecting);
            },
            { threshold: 0.1 } // Trigger when at least 10% of the element is visible
        );

        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef); // Use the stored value here
            }
        };
    }, []);


    return <div>
        <div ref={dropdownRef}></div>
            <FixedDropdownWrapper isScrollingUp={isScrollingUp} isVisible={isVisible}>
                <div
                    style={{
                        width:'100%',
                        maxWidth:'1370px',
                        display: 'flex',
                        justifyContent: 'space-between',
                    }}
                >
                    {
                        (backButtonLink && backButtonText) &&
                        <BackButton
                            ref={backButtonRef}
                            href={backButtonLink}
                        >
                            <Image
                                src={SliderArrowWhiteIcon}
                                alt={'<'}
                                style={{
                                    marginBottom:'5px',
                                    transform: 'scaleX(-1)',
                                }}
                            />
                            {backButtonText}
                        </BackButton>
                    }
                    <Wrapper>
                        {items?.map((item,index) => renderItem(item,index))}
                    </Wrapper>

                    {
                        (backButtonLink && backButtonText) &&
                        <div style={{
                            paddingRight:backButtonRef.current ? `43px` : '0px'
                        }}>
                        </div>
                    }
                </div>

            </FixedDropdownWrapper>
    </div>
}
